export const BusinessLabelArchetypeValues = {
  FINANCE: "FINANCE",
  ACTIVITY: "ACTIVITY",
  PRODUCT: "PRODUCT",
  BUSINESS_RELATIONS: "BUSINESS_RELATIONS",
} as const;

export const BusinessLabelArchetypeLabels: Record<string, string> = {
  [BusinessLabelArchetypeValues.FINANCE]: "Finance",
  [BusinessLabelArchetypeValues.ACTIVITY]: "Activity",
  [BusinessLabelArchetypeValues.PRODUCT]: "Product",
  [BusinessLabelArchetypeValues.BUSINESS_RELATIONS]: "Business Relations",
};
